var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('WechatCustomerService',{attrs:{"kfUrl":_vm.wechatKfUrl,"visible":true,"pcOffsetRight":"2px","pcOffsetBottom":"30px"}}),(_vm.showBackToTop)?_c('BackToTop'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }